import { MessageSquare, Calculator, ClipboardList, HardHat, KeyRound } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageSquare,
    title: "Contacto",
    desc: "Nos escribís por WhatsApp y entendemos lo que necesitás.",
  },
  {
    n: "02",
    icon: Calculator,
    title: "Presupuesto",
    desc: "Cotizamos con detalle y sin compromiso.",
  },
  {
    n: "03",
    icon: ClipboardList,
    title: "Planificación",
    desc: "Definimos materiales, equipos y plazos.",
  },
  {
    n: "04",
    icon: HardHat,
    title: "Ejecución",
    desc: "Trabajamos con prolijidad y comunicación constante.",
  },
  {
    n: "05",
    icon: KeyRound,
    title: "Entrega",
    desc: "Revisamos cada detalle y te entregamos la obra terminada.",
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="relative bg-[var(--fb-bg-alt)] py-20 md:py-32"
    >
      <div className="fb-container">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">Proceso</span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl text-[var(--fb-ink)] font-medium tracking-tight balance leading-[1.02]">
            Cinco pasos simples,
            <br className="hidden md:block" /> un resultado prolijo.
          </h2>
        </div>

        {/* Desktop / tablet timeline */}
        <div className="mt-14 hidden md:block">
          <div className="relative grid grid-cols-5 gap-4">
            <div className="absolute left-0 right-0 top-[44px] h-px bg-[var(--fb-line)]" />
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  className="relative reveal"
                  style={{ transitionDelay: `${i * 80}ms` }}
                  data-testid={`process-step-${i}`}
                >
                  <div className="flex justify-center">
                    <div className="relative bg-[var(--fb-bg-alt)] px-3">
                      <span className="inline-flex h-[88px] w-[88px] items-center justify-center rounded-full bg-white border border-[var(--fb-line)] text-[var(--fb-ink)] group hover:border-[var(--fb-accent)] transition-colors">
                        <Icon
                          className="h-7 w-7 group-hover:text-[var(--fb-accent)] transition-colors"
                          strokeWidth={1.5}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="mt-5 text-center">
                    <span className="text-xs font-semibold tracking-[0.18em] text-[var(--fb-accent)]">
                      {s.n}
                    </span>
                    <h3 className="mt-1 font-display text-xl font-semibold tracking-tight">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm text-[var(--fb-mute)] leading-relaxed max-w-[200px] mx-auto pretty">
                      {s.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mobile vertical timeline */}
        <ol className="mt-12 md:hidden relative pl-7">
          <span className="absolute left-[10px] top-2 bottom-2 w-px bg-[var(--fb-line)]" />
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <li
                key={s.n}
                className="relative pb-8 last:pb-0 reveal"
                data-testid={`process-step-mobile-${i}`}
              >
                <span className="absolute -left-7 top-1 h-5 w-5 rounded-full bg-[var(--fb-ink)] border-4 border-[var(--fb-bg-alt)]" />
                <div className="flex items-center gap-3">
                  <span className="text-xs font-semibold tracking-[0.18em] text-[var(--fb-accent)]">
                    {s.n}
                  </span>
                  <Icon className="h-4 w-4 text-[var(--fb-ink-soft)]" />
                </div>
                <h3 className="mt-1 font-display text-xl font-semibold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-1.5 text-sm text-[var(--fb-mute)] leading-relaxed pretty">
                  {s.desc}
                </p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
